import BottomNav from './bottom-nav';

import './bottom-nav.scss';

export default BottomNav;
